export var S132Outcome;
(function (S132Outcome) {
    S132Outcome["Understood"] = "understood";
    S132Outcome["NotUnderstood"] = "notUnderstood";
    S132Outcome["UnableToAssess"] = "unableToAssess";
})(S132Outcome || (S132Outcome = {}));
export var S132WithdrawalReason;
(function (S132WithdrawalReason) {
    S132WithdrawalReason["WrongPatient"] = "wrongPatient";
    S132WithdrawalReason["Duplicate"] = "duplicate";
    S132WithdrawalReason["Other"] = "other";
})(S132WithdrawalReason || (S132WithdrawalReason = {}));
//# sourceMappingURL=S132.js.map